import React from 'react';
import {
  useTranslation,
  translatePage,
} from '@ikea-customer-self-serve/gatsby-plugin-translations';

import SiteMetadata from '../components/SiteMetadata';
import TMarkUp from '../components/TMarkUp';

const NotFoundPage = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <SiteMetadata pageTitle={t('app.htmlTitle')} />
      <h2 className="h2">
        <TMarkUp value={t('error.title-404')} />
      </h2>
      <p>
        <TMarkUp value={t('error.description-404')} />
      </p>
    </>
  );
};

export default translatePage()(NotFoundPage);
